module.exports = __webpack_public_path__ + "img/viva-com-logo-circle.c703f32b.svg";